import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import cachios from 'cachios'
import astrolable from '../assets/astro.jpg'
import research from '../assets/journal.jpg'
import st2 from '../assets/strategy2.jpeg'
import researchs from '../assets/researchpdf.pdf'


class HomeResearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            langeng: localStorage.getItem('lang') ? false : true
        }

    }

    componentWillMount() {
        //RESEARCH DIVISION
        cachios.get(BASE + 'api/research_cluster?from=0&size=8', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                this.setState({
                    mission: data.data.hits.hits
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }

    render() {
        return (
            <div className="newhomebook" id="homeresearch">
                <div className="headertopdiv"></div>
                <div className="newhomebookdiv">
                    <div className="newhometitle">
                        <Link to='/research/cluster'>{this.props.isArabic == true ? 'أبحاث' : 'Research'}</Link>
                    </div>
                    {/* <div className="newhometext">
                        Research cluster offers a fluid interdisciplinary, flexible ecosystem environment comprised of 8 broad virtual entities
                    </div> */}
                    {/* {this.state.mission ?
                                this.state.mission.map((inst, index) => {
                                        return <div className="mainlink">
                                            <Link to={{ pathname: '/project/' + `${inst._source.nid[0]}` }}>
                                                {inst._source.title[0].replace("and", "&")}
                                            </Link>
                                        </div>
                                }) : ''} */}
                    <div className='row'>
                        <div>

                            <div className="mainlink">
                                <Link to={{ pathname: '/report' }}>
                                    Research Division
                                </Link>
                            </div>
                            
                            <div className="mainlink">
                                <Link to={{ pathname: '/research/cluster' }}>
                                    Research Clusters
                                </Link>
                            </div>
                            {/* <div className="mainlink">
                                <Link to={{ pathname: '/cis_publication' }}>
                                CIS Publication
                                </Link>
                            </div> */}
                            <div className="mainlink">
                                <Link to={{ pathname: '/ongoing' }}>
                                    Ongoing Research
                                </Link>
                            </div>
                            <div className="mainlink">
                                <Link to={{ pathname: '/research/faculty' }}>
                                CIS Faculty
                                </Link>
                            </div>
                            <div className="mainlink">
                                <Link to={{ pathname: '/theses' }}>
                                CIS Student Theses
                                </Link>
                            </div>

                            {/* <div className="mainlink">
                                        <Link to="/research/faculty" onClick={(event) => { event.preventDefault(); alert("Under Construction") }} >
                                            RD Annual Report
                                        </Link>
                                    </div> */}
                        </div>
                        <div className="mainphotolink">
                            <a target='_blank' href="https://www.hbku.edu.qa/en/cis/astrolabe" >
                                <img src={astrolable} />
                            </a>

                            {/* <div onClick={()=>alert("Under Construction")}>
                                    Astrolable Journal
                                    </div> */}
                        </div>
                        <div className="mainphotolink ">
                            <a target='_blank' href="https://brill.com/view/journals/jie/jie-overview.xml?language=en#:~:text=The%20focus%20of%20the%20Journal,to%20various%20sectors%20of%20contemporary">
                                <img src={research} />
                            </a>

                            {/* <div onClick={()=>alert("Under Construction")}>
                                    Astrolable Journal
                                    </div> */}
                        </div>
                        <div className="mainphotolink ">
                            <a target='_blank' href={researchs}>
                                <img src={st2} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeResearch;